import React, { forwardRef } from 'react'

import { Button } from '../button'
import { classes } from '../utils'

type Variant = 'ghost' | 'critical'
type Props = {
  open?: boolean
  variant?: Variant
} & React.ButtonHTMLAttributes<HTMLButtonElement>
const TableActionsHeaderButton = forwardRef<HTMLButtonElement, Props>(
  ({ open, className, variant = 'ghost', ...props }, ref) => {
    return (
      <Button
        ref={ref}
        size="icon"
        variant={variant}
        className={classes(
          'flex h-8 w-8 items-center justify-center border-none hover:bg-background-surface/70 active:bg-background-surface/80',
          {
            'bg-background-surface/80': open,
          },
          {
            'cursor-not-allowed text-foreground-subtle text-opacity-50':
              props.disabled,
          },
          className,
        )}
        {...props}
      />
    )
  },
)
TableActionsHeaderButton.displayName = 'TableActionsHeaderButton'

export default TableActionsHeaderButton
